import React from 'react';

/* @material-ui */
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

// assets
import useStyles from '../../../../../../assets/styles/jss/pages/checkout/checkout';

const PaymentMethodItemSkeleton = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <Grid container alignItems='center' className={classes.paymentMethodItemSkeleton} spacing={3}>
            <Grid item>
                <Skeleton variant="circle" width={26} height={26} /> {/* radio */}
            </Grid>
            <Grid item className="ml-2">
                <Skeleton variant="text" width={isDesktop ? 300: 260} height={24} /> {/* text */}
            </Grid>
        </Grid>
    );
};

export default PaymentMethodItemSkeleton;